// mockData.ts
// TideLab 全局 mock 数据，开发环境可直接 import 使用
import { ManualTestTrade, ManualTestStats, Strategy, BacktestResult, LiveTracking, StrategyNote } from '../types'
import { User } from '../types/auth'

export const mockUser: User = {
  id: 'user-1',
  email: 'test@tidelab.com',
  username: '测试用户',
  avatar_url: '',
  created_at: '2024-01-01T08:00:00Z',
  updated_at: '2024-01-01T08:00:00Z'
}

export const mockStrategies: Strategy[] = [
  {
    id: 'strategy-1',
    name: '趋势跟踪策略',
    name_en: 'Trend Following',
    name_zh: '趋势跟踪策略',
    type: 'trend',
    market: 'crypto',
    market_symbol: 'BTC/USD',
    timeframe: '1h',
    status: 'live',
    description: '基于均线的趋势跟踪策略',
    description_en: 'Trend following based on MA',
    description_zh: '基于均线的趋势跟踪策略',
    entry_rules: '均线金叉做多',
    exit_rules: '均线死叉平仓',
    risk_management: '单次最大亏损1%',
    created_by: 'user-1',
    created_at: '2024-01-01T10:00:00Z',
    updated_at: '2024-01-01T10:00:00Z'
  },
  {
    id: 'strategy-2',
    name: '网格交易策略',
    name_en: 'Grid Trading',
    name_zh: '网格交易策略',
    type: 'grid',
    market: 'crypto',
    market_symbol: 'ETH/USD',
    timeframe: '15m',
    status: 'test',
    description: '在价格区间内进行网格交易的策略',
    description_en: 'Grid trading in price range',
    description_zh: '在价格区间内进行网格交易的策略',
    entry_rules: '区间下沿做多，上沿做空',
    exit_rules: '止盈止损',
    risk_management: '单格最大亏损0.5%',
    created_by: 'user-1',
    created_at: '2024-02-21T10:00:00Z',
    updated_at: '2024-02-21T10:00:00Z'
  }
]

export const mockManualTestTrades: ManualTestTrade[] = [
  {
    id: 'trade-1',
    strategy_id: 'strategy-1',
    entry_time: '2024-03-01T09:00:00Z',
    exit_time: '2024-03-01T15:00:00Z',
    direction: 'long',
    entry_price: 40000,
    exit_price: 41000,
    size: 1,
    initial_risk: 1000,
    pnl_amount: 1000,
    pnl_r: 1.5,
    reason_entry: '突破均线',
    reason_exit: '触及目标位',
    manual_override: false,
    notes: '表现良好',
    created_by: 'user-1',
    created_at: '2024-03-01T09:00:00Z',
    updated_at: '2024-03-01T15:00:00Z'
  },
  {
    id: 'trade-2',
    strategy_id: 'strategy-1',
    entry_time: '2024-03-02T10:00:00Z',
    exit_time: '2024-03-02T18:00:00Z',
    direction: 'short',
    entry_price: 41000,
    exit_price: 40500,
    size: 1,
    initial_risk: 1000,
    pnl_amount: -500,
    pnl_r: -0.7,
    reason_entry: '反弹做空',
    reason_exit: '止损',
    manual_override: false,
    notes: '止损出场',
    created_by: 'user-1',
    created_at: '2024-03-02T10:00:00Z',
    updated_at: '2024-03-02T18:00:00Z'
  },
  {
    id: 'trade-3',
    strategy_id: 'strategy-2',
    entry_time: '2024-03-05T11:00:00Z',
    exit_time: '2024-03-05T20:00:00Z',
    direction: 'long',
    entry_price: 3000,
    exit_price: 3200,
    size: 2,
    initial_risk: 1000,
    pnl_amount: 400,
    pnl_r: 0.8,
    reason_entry: '区间下沿做多',
    reason_exit: '区间上沿止盈',
    manual_override: true,
    notes: '手动干预',
    created_by: 'user-1',
    created_at: '2024-03-05T11:00:00Z',
    updated_at: '2024-03-05T20:00:00Z'
  }
]

export const mockManualTestStats: ManualTestStats = {
  total_trades: 3,
  winning_trades: 2,
  losing_trades: 1,
  win_rate: 0.67,
  avg_r_value: 0.53,
  max_r_value: 1.5,
  min_r_value: -0.7,
  max_drawdown: -500,
  total_pnl: 900,
  avg_pnl_per_trade: 300,
  long_trades: 2,
  short_trades: 1,
  long_win_rate: 1,
  short_win_rate: 0,
  avg_trade_duration: 6.5,
  manual_override_count: 1,
  manual_override_rate: 0.33
}

export const mockBacktestResults: BacktestResult[] = [
  {
    id: 'backtest-1',
    strategy_id: 'strategy-1',
    platform: 'Binance',
    start_date: '2024-01-01T00:00:00Z',
    end_date: '2024-03-01T00:00:00Z',
    total_return: 20.5,
    max_drawdown: -12.3,
    sharpe_ratio: 1.8,
    win_rate: 0.6,
    profit_factor: 1.7,
    trade_count: 20,
    avg_trade_duration: 5.2,
    equity_curve: [],
    drawdown_curve: [],
    monthly_returns: [],
    trade_log: [],
    parameters_used: {},
    notes: '回测表现良好',
    created_at: '2024-03-01T00:00:00Z'
  }
]

export const mockLiveTracking: LiveTracking[] = [
  {
    id: 'live-1',
    strategy_id: 'strategy-1',
    platform: 'Binance',
    tracking_period_start: '2024-03-01T00:00:00Z',
    tracking_period_end: '',
    deviation_pct: 0.5,
    actual_return: 8.5,
    actual_drawdown: 2.1,
    actual_trade_count: 12,
    backtest_comparison: {},
    notes: '实盘表现稳定',
    status: 'active',
    created_by: 'user-1',
    created_at: '2024-03-01T00:00:00Z',
    updated_at: '2024-03-10T00:00:00Z'
  }
]

export const mockNotes: StrategyNote[] = [
  {
    id: 'note-1',
    strategy_id: 'strategy-1',
    title: '每周复盘',
    content: '本周策略表现良好，继续观察。',
    is_version_update: false,
    impact_scope: '全部',
    created_by: 'user-1',
    created_at: '2024-03-08T12:00:00Z'
  }
] 